{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Live chat campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "CARD": {
        "STATUS": {
          "ENABLED": "เปิด",
          "DISABLED": "ปิด"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "ส่งโดย",
          "BOT": "บอท",
          "FROM": "จาก",
          "URL": "ลิ้ง:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No live chat campaigns are available",
        "SUBTITLE": "Connect with your customers using proactive messages.  Click 'Create campaign' to get started."
      },
      "CREATE": {
        "TITLE": "Create a live chat campaign",
        "CANCEL_BUTTON_TEXT": "ยกเลิก",
        "CREATE_BUTTON_TEXT": "สร้าง",
        "FORM": {
          "TITLE": {
            "LABEL": "หัวข้อ",
            "PLACEHOLDER": "กรุณาใส่หัวข้อแคมเปญ",
            "ERROR": "โปรดระบุหัวข้อด้วย"
          },
          "MESSAGE": {
            "LABEL": "ข้อความ",
            "PLACEHOLDER": "โปรดระบุข้อความของแคมเปญด้วย",
            "ERROR": "โปรดระบุข้อความด้วย"
          },
          "INBOX": {
            "LABEL": "เลือกกล่องข้อความ",
            "PLACEHOLDER": "เลือกกล่องข้อความ",
            "ERROR": "โปรดเลือกกล่องข้อความ"
          },
          "SENT_BY": {
            "LABEL": "ส่งโดย",
            "PLACEHOLDER": "Please select sender",
            "ERROR": "โปรดระบุชื่อผู้ส่ง"
          },
          "END_POINT": {
            "LABEL": "ลิ้ง",
            "PLACEHOLDER": "โปรดระบุลิ้งด้วย",
            "ERROR": "กรุณากรอกลิ้งที่ถูกต้อง"
          },
          "TIME_ON_PAGE": {
            "LABEL": "เวลาของหน้า (วินาที)",
            "PLACEHOLDER": "โปรดระบุเวลาด้วย",
            "ERROR": "กรุณาระบุเวลาที่อยู่ในหน้านั้นด้วย"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Other preferences",
            "ENABLED": "เปิดเเคมเปญ",
            "TRIGGER_ONLY_BUSINESS_HOURS": "เปิดใช้แค่ในเวลาทำการ"
          },
          "BUTTONS": {
            "CREATE": "สร้าง",
            "CANCEL": "ยกเลิก"
          },
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign created successfully",
            "ERROR_MESSAGE": "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง."
          }
        }
      },
      "EDIT": {
        "TITLE": "Edit live chat campaign",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign updated successfully",
            "ERROR_MESSAGE": "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No SMS campaigns are available",
        "SUBTITLE": "Launch an SMS campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "PROCESSING": "Processing",
          "COMPLETED": "เสร็จสิ้น",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create SMS campaign",
        "CANCEL_BUTTON_TEXT": "ยกเลิก",
        "CREATE_BUTTON_TEXT": "สร้าง",
        "FORM": {
          "TITLE": {
            "LABEL": "หัวข้อ",
            "PLACEHOLDER": "กรุณาใส่หัวข้อแคมเปญ",
            "ERROR": "โปรดระบุหัวข้อด้วย"
          },
          "MESSAGE": {
            "LABEL": "ข้อความ",
            "PLACEHOLDER": "โปรดระบุข้อความของแคมเปญด้วย",
            "ERROR": "โปรดระบุข้อความด้วย"
          },
          "INBOX": {
            "LABEL": "เลือกกล่องข้อความ",
            "PLACEHOLDER": "เลือกกล่องข้อความ",
            "ERROR": "โปรดเลือกกล่องข้อความ"
          },
          "AUDIENCE": {
            "LABEL": "ผู้รับ",
            "PLACEHOLDER": "เลือกป้ายกำกับลูกค้า",
            "ERROR": "โปรดระบุผู้รับ"
          },
          "SCHEDULED_AT": {
            "LABEL": "วันเริ่มแคมเปญ",
            "PLACEHOLDER": "โปรดระบุเวลา",
            "ERROR": "โปรดระบุวันเริ่มแคมเปญ"
          },
          "BUTTONS": {
            "CREATE": "สร้าง",
            "CANCEL": "ยกเลิก"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS campaign created successfully",
            "ERROR_MESSAGE": "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง."
          }
        }
      }
    },
    "WHATSAPP": {
      "HEADER_TITLE": "WhatsApp campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No WhatsApp campaigns are available",
        "SUBTITLE": "Launch a WhatsApp campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "PROCESSING": "Processing",
          "COMPLETED": "เสร็จสิ้น",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create WhatsApp campaign",
        "CANCEL_BUTTON_TEXT": "ยกเลิก",
        "CREATE_BUTTON_TEXT": "สร้าง",
        "FORM": {
          "TITLE": {
            "LABEL": "หัวข้อ",
            "PLACEHOLDER": "กรุณาใส่หัวข้อแคมเปญ",
            "ERROR": "โปรดระบุหัวข้อด้วย"
          },
          "INBOX": {
            "LABEL": "เลือกกล่องข้อความ",
            "PLACEHOLDER": "เลือกกล่องข้อความ",
            "ERROR": "โปรดเลือกกล่องข้อความ"
          },
          "TEMPLATE": {
            "LABEL": "WhatsApp Template",
            "PLACEHOLDER": "Select a template",
            "INFO": "Select a template to use for this campaign.",
            "ERROR": "Template is required",
            "PREVIEW_TITLE": "Process {templateName}",
            "LANGUAGE": "Language",
            "CATEGORY": "Category",
            "VARIABLES_LABEL": "Variables",
            "VARIABLE_PLACEHOLDER": "Enter value for {variable}"
          },
          "AUDIENCE": {
            "LABEL": "ผู้รับ",
            "PLACEHOLDER": "เลือกป้ายกำกับลูกค้า",
            "ERROR": "โปรดระบุผู้รับ"
          },
          "SCHEDULED_AT": {
            "LABEL": "วันเริ่มแคมเปญ",
            "PLACEHOLDER": "โปรดระบุเวลา",
            "ERROR": "โปรดระบุวันเริ่มแคมเปญ"
          },
          "BUTTONS": {
            "CREATE": "สร้าง",
            "CANCEL": "ยกเลิก"
          },
          "API": {
            "SUCCESS_MESSAGE": "WhatsApp campaign created successfully",
            "ERROR_MESSAGE": "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "คุณต้องการที่จะลบไหม?",
      "DESCRIPTION": "The delete action is permanent and cannot be reversed.",
      "CONFIRM": "ลบ",
      "API": {
        "SUCCESS_MESSAGE": "ลบแคมเปญเรียบร้อยแล้ว",
        "ERROR_MESSAGE": "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง."
      }
    }
  }
}
